import { deltaClass, money } from "../utils";

const TopDownDriversCard = ({ rows }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between">
        <h5>Top Down Drivers</h5>
      </div>
      <div className="text-xs opacity-60 mt-1">
        Biggest contributors to revenue decline ranked by impact.
      </div>
      <div className="-mx-2">
        <table className="with-line mt-2">
          <thead>
            <tr>
              <th className="whitespace-nowrap">Rank</th>
              <th>Driver</th>
              <th className="text-right whitespace-nowrap">Current</th>
              <th className="text-right whitespace-nowrap">Previous</th>
              <th className="text-right whitespace-nowrap">Delta</th>
              <th className="text-right whitespace-nowrap">Contribution</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={`down-${row.rank}-${row.driver}`}>
                <td className="whitespace-nowrap">{row.rank}</td>
                <td>{row.driver}</td>
                <td className="text-right whitespace-nowrap">{money(row.current)}</td>
                <td className="text-right whitespace-nowrap">{money(row.previous)}</td>
                <td className={`text-right whitespace-nowrap ${deltaClass(row.delta)}`}>
                  {money(row.delta)}
                </td>
                <td className="text-right whitespace-nowrap">{row.contribution}</td>
              </tr>
            ))}
            {rows.length === 0 ? (
              <tr>
                <td colSpan={6} className="text-center opacity-60 py-4">
                  No down drivers.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopDownDriversCard;
